import ComponentLoader from 'components/ComponentLoader'
import React from 'react'

function loadComponent () {
  return import(/* webpackChunkName: "modules/training/modules/training-exercises/containers/ViewExercisesList" */ 'modules/training/modules/training-exercises/containers/ViewExercisesList')
}

export default function getExercisesComponentRouteUtil (props) {
  if (EXERCISES || (SERVER && global.EXERCISES)) {
    const Component = require('modules/training/modules/training-exercises/containers/ViewExercisesList').default
    return <Component {...props} />
  } else {
    return (
      <ComponentLoader
        loadComponent={loadComponent}
        {...props}
      />
    )
  }
}
